import type { CommonPlugin } from "zudoku";

export const HideSchemasPlugin: CommonPlugin = {
  getHead: () => (
    <style>
      {`
        a[href*="~schemas"], a[href$="~schemas"] { display: none !important; }

        .prose {
          --tw-prose-body: hsl(0 0% 14.5%);
          --tw-prose-headings: hsl(0 0% 14.5%);
          --tw-prose-lead: hsl(0 0% 20.5%);
          --tw-prose-links: hsl(250.91 91.22% 59.8%);
          --tw-prose-bold: hsl(0 0% 14.5%);
          --tw-prose-counters: hsl(0 0% 55.6%);
          --tw-prose-bullets: hsl(0 0% 92.94%);
          --tw-prose-hr: hsl(0 0% 92.94%);
          --tw-prose-quotes: hsl(0 0% 14.5%);
          --tw-prose-quote-borders: hsl(0 0% 92.94%);
          --tw-prose-captions: hsl(0 0% 55.6%);
          --tw-prose-code: hsl(0 0% 14.5%);
          --tw-prose-th-borders: hsl(0 0% 92.94%);
          --tw-prose-td-borders: hsl(0 0% 92.94%);
        }
        .dark .prose {
          --tw-prose-body: hsl(0 0% 98%);
          --tw-prose-headings: hsl(0 0% 98%);
          --tw-prose-lead: hsl(240 5% 64.9%);
          --tw-prose-links: hsl(263.82 86.08% 69.02%);
          --tw-prose-bold: hsl(0 0% 98%);
          --tw-prose-counters: hsl(240 5% 64.9%);
          --tw-prose-bullets: hsl(240 3.7% 15.9%);
          --tw-prose-hr: hsl(240 3.7% 15.9%);
          --tw-prose-quotes: hsl(0 0% 98%);
          --tw-prose-quote-borders: hsl(240 3.7% 15.9%);
          --tw-prose-captions: hsl(240 5% 64.9%);
          --tw-prose-code: hsl(0 0% 98%);
          --tw-prose-th-borders: hsl(240 3.7% 15.9%);
          --tw-prose-td-borders: hsl(240 3.7% 15.9%);
        }
      `}
    </style>
  ),
};
